export default __webpack_public_path__ + "static/media/add-square.4b981420.svg";